import { render, staticRenderFns } from "./NotificationsBell.vue?vue&type=template&id=62ec1e8f&scoped=true"
import script from "./NotificationsBell.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationsBell.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NotificationsBell.vue?vue&type=style&index=0&id=62ec1e8f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ec1e8f",
  null
  
)

export default component.exports